// SCACTypeColumns.js

import React from 'react';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';

export const SCACTypeColumns = (handleEdit, handleDelete) => {
    return [
        {
            field: 'scac_type',
            headerName: 'SCAC Type Code',
            minWidth: 150,
            sortable: true,

        },
        {
            field: 'description',
            headerName: 'Description',
            flex: 2,
            minWidth: 450,
            sortable: true,
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 150,
            align: 'right',
            renderCell: (params) => (
                <div>
                    <IconButton aria-label="edit" onClick={() => handleEdit(params.row)}>
                        <ModeEditIcon className='ml-5 edit-color' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleDelete(params.row)}>
                        <DeleteIcon className='ml-5 delete-color' />
                    </IconButton>
                </div>
            ),
        },
    ];
};

